import { emphasizeAndEscapeText } from './emphasize-text';
import type { SearchProps } from './result-base';
import SearchResultBase from './result-base';

export type { SearchProps };
export { SearchResultBase, emphasizeAndEscapeText };
